/**
 * @generated SignedSource<<548492858d45f5fbafbb71f1a08a7c7b>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type simpleIssueCard_versionIssueAssociatedDesigns$data = {
  readonly fieldsByIdOrAlias: ReadonlyArray<{
    readonly __typename: "JiraIssueTypeField";
    readonly issueType: {
      readonly avatar: {
        readonly xsmall: string | null | undefined;
      } | null | undefined;
      readonly name: string;
    };
  } | {
    readonly __typename: "JiraSingleLineTextField";
    readonly text: string;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  } | null | undefined>;
  readonly key: string;
  readonly webUrl: AGG$URL;
  readonly " $fragmentType": "simpleIssueCard_versionIssueAssociatedDesigns";
};
export type simpleIssueCard_versionIssueAssociatedDesigns$key = {
  readonly " $data"?: simpleIssueCard_versionIssueAssociatedDesigns$data;
  readonly " $fragmentSpreads": FragmentRefs<"simpleIssueCard_versionIssueAssociatedDesigns">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "simpleIssueCard_versionIssueAssociatedDesigns",
  "selections": [
    {
      "kind": "RequiredField",
      "field": {
        "kind": "ScalarField",
        "name": "key"
      },
      "action": "THROW",
      "path": "key"
    },
    {
      "kind": "RequiredField",
      "field": {
        "kind": "ScalarField",
        "name": "webUrl"
      },
      "action": "THROW",
      "path": "webUrl"
    },
    {
      "kind": "RequiredField",
      "field": {
        "args": [
          {
            "kind": "Literal",
            "name": "idsOrAliases",
            "value": [
              "issuetype",
              "summary"
            ]
          },
          {
            "kind": "Literal",
            "name": "ignoreMissingFields",
            "value": true
          }
        ],
        "kind": "LinkedField",
        "name": "fieldsByIdOrAlias",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "__typename"
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "kind": "RequiredField",
                "field": {
                  "concreteType": "JiraIssueType",
                  "kind": "LinkedField",
                  "name": "issueType",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "RequiredField",
                      "field": {
                        "kind": "ScalarField",
                        "name": "name"
                      },
                      "action": "THROW",
                      "path": "fieldsByIdOrAlias.issueType.name"
                    },
                    {
                      "concreteType": "JiraAvatar",
                      "kind": "LinkedField",
                      "name": "avatar",
                      "plural": false,
                      "selections": [
                        {
                          "kind": "ScalarField",
                          "name": "xsmall"
                        }
                      ]
                    }
                  ]
                },
                "action": "THROW",
                "path": "fieldsByIdOrAlias.issueType"
              }
            ],
            "type": "JiraIssueTypeField"
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "kind": "RequiredField",
                "field": {
                  "kind": "ScalarField",
                  "name": "text"
                },
                "action": "THROW",
                "path": "fieldsByIdOrAlias.text"
              }
            ],
            "type": "JiraSingleLineTextField"
          }
        ],
        "storageKey": "fieldsByIdOrAlias(idsOrAliases:[\"issuetype\",\"summary\"],ignoreMissingFields:true)"
      },
      "action": "THROW",
      "path": "fieldsByIdOrAlias"
    }
  ],
  "type": "JiraIssue"
};

(node as any).hash = "293ef6f7a36c1d615e6dc27559c1d40e";

export default node;
